import{m as n}from"./chunk-HBP5N4FR.js";n();var o=`.dapp-core-component__extensionLoginButton-styles__extension-login {
  box-sizing: border-box;
}

.dapp-core-component__extensionLoginButton-styles__login-text {
  box-sizing: border-box;
}

.dapp-core-component__extensionLoginButton-styles__no-extension-button-wrapper {
  box-sizing: border-box;
}

.dapp-core-component__extensionLoginButton-styles__noExtensionButtonContent {
  box-sizing: border-box;
}

.dapp-core-component__extensionLoginButton-styles__no-extension-button-title {
  box-sizing: border-box;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(o));var s={"extension-login":"dapp-core-component__extensionLoginButton-styles__extension-login",extensionLogin:"dapp-core-component__extensionLoginButton-styles__extension-login","login-text":"dapp-core-component__extensionLoginButton-styles__login-text",loginText:"dapp-core-component__extensionLoginButton-styles__login-text","no-extension-button-wrapper":"dapp-core-component__extensionLoginButton-styles__no-extension-button-wrapper",noExtensionButtonWrapper:"dapp-core-component__extensionLoginButton-styles__no-extension-button-wrapper",noExtensionButtonContent:"dapp-core-component__extensionLoginButton-styles__noExtensionButtonContent","no-extension-button-title":"dapp-core-component__extensionLoginButton-styles__no-extension-button-title",noExtensionButtonTitle:"dapp-core-component__extensionLoginButton-styles__no-extension-button-title"};export{o as a,s as b};
//# sourceMappingURL=chunk-KV4JMXGQ.js.map
